import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import TableRows from './TableRows';

function GeneralInformationTable({rowsData,setRowsData}){

    const addTableRows = () => {
        if (rowsData.length >= 20) {
            window.alert('Maximum 20 rows allowed.');
            return;
        }
        const rowsInput = {
            partNumber: '',
            reasonForScrap: '',
            quantity: '',
            PO_SA_Number: '',
            QN_RFA_Number: '',
            serialNumber: ''
        };
        setRowsData([...rowsData, rowsInput]);
    }
   const deleteTableRows = (index)=>{
        const rows = [...rowsData];
        rows.splice(index, 1);
        setRowsData(rows);
   }
 
   const handleChange = (index, evnt)=>{
    
    const { name, value } = evnt.target;
    const rowsInput = [...rowsData];
    rowsInput[index][name] = value;
    setRowsData(rowsInput);
  
 
 
}
    return(
        <div>
            <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">General Information</h5></div></div>
            <div className="marginLeft">
            <div className="row"><div className="GeneralInfoNote"><b>Enter N/A if the following fields are not applicable (PO/SA Number, QN/RFA Number, Serial Number). Do not leave these fields blank</b></div></div>
            <div className="row"><div className="GeneralInfoNote" style={{color:'red'}}><b>Maximum 20 rows allowed per Scrap form</b></div> </div>
            <div className="row">
                <div className="col-12">
                <table className="table">
                    <thead>
                      <tr>
                          <th>ID</th>
                          <th>Part Number<label style={{color:'red'}}>*</label></th>
                          <th>Reason for Scrap<label style={{color:'red'}}>*</label></th>
                          <th>Quantity<label style={{color:'red'}}>*</label></th>
                          <th>PO/SA Number<label style={{color:'red'}}>*</label></th>
                          <th>QN/RFA Number<label style={{color:'red'}}>*</label></th>
                          <th>Serial Number<label style={{color:'red'}}>*</label></th>                          
                          <th><span className="btn btn-outline-success" onClick={addTableRows} disabled={rowsData.length >= 20} style={rowsData.length >= 20 ? { pointerEvents: 'none', opacity: 0.5 } : {}}>+</span></th>
                      </tr>
                    </thead>
                   <tbody>
                   <TableRows rowsData={rowsData} deleteTableRows={deleteTableRows} handleChange={handleChange} />
                   </tbody> 
                </table>
                </div>                
            </div>

            <div>
            <span className="btn btn-outline-success" onClick={addTableRows} disabled={rowsData.length >= 20} style={rowsData.length >= 20 ? { pointerEvents: 'none', opacity: 0.5 } : {}}>+Add </span>
            </div>
            </div>
        </div>
    )


}

export default GeneralInformationTable;